import { Injectable } from '@angular/core';
import  { Http } from '@angular/http';

//import {data} from './data';
import { Headers } from '@angular/http';
//import { Observable } from 'rxjs/Observable';
//import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Platform} from 'ionic-angular';
import { AlertController } from 'ionic-angular';
//import { LoadingController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { Events } from 'ionic-angular';

declare let navigator: any;
declare let Connection: any;
@Injectable()

export class MydataService {
	kiloSabjiurl: string;
	kiloSabjiJSONdata: string;
	checkInternetStatus:string;
//	datat: string;
	public helloString: string="true";


   constructor(public _http: Http,private platform: Platform,public alerCtrl: AlertController,/*public loadingCtrl: LoadingController */public loading: LoadingController,public events: Events){}

navigationRef(){
	this.events.publish('user:login');
	
}
  checkInternetFunction(){
    var networkState = navigator.connection && navigator.connection.type;
 //     //console.log("hiiiiiii--->"+networkState);
 if(networkState=='undefined'){
    this.checkInternetStatus='0';
 //alert("o");
  this.showAlert();
 }else if(networkState=='none'){
   this.checkInternetStatus='0';
     this.showAlert();
   //alert("0");

 }else{
 // alert("1");
   this.checkInternetStatus='1';
 }

  return this.checkInternetStatus;
 }
  showAlert=function() {

   let alert = this.alerCtrl.create({
     // title: 'New Friend!',
      subTitle: 'No Internet Connection',
      buttons: [ {
          text: 'Ok',
          handler: data => {
      this.checkInternetFunction();
          }
   }
   ]

    });

    alert.present();
  }

 postJSON(kiloSabjiurl,kiloSabjiJSONdata){
	  this.kiloSabjiurl = kiloSabjiurl
    this.kiloSabjiJSONdata = kiloSabjiJSONdata
	/* let loading = this.loadingCtrl.create({
    content: 'Please wait...'
  });
*/
// let loader = this.loading.create({
//     content: '',
//   });

	 //console.log("Service--->"+"\n"+"Kilo Sabji Url--->"+this.kiloSabjiurl+"\n"+"Kilo Sabji Json --->"+this.kiloSabjiJSONdata);
	  var headers = new Headers();
	  headers.append('Content-Type','application/x-www-form-urlencoded');
	//  loader.present().then(() => {this._http.post(this.kiloSabjiurl,this.kiloSabjiJSONdata,
	//   {
	//       headers:headers
	//   })
	// .map(res => res.json());
	// loader.dismiss();
  // });
	  return this._http.post(this.kiloSabjiurl,this.kiloSabjiJSONdata,
	  {
	      headers:headers
	  })
	.map(res => res.json())  ;
////console.log("response json"+res.json());
  }
}

















 //constructor(private _http: Http ) { }

  /* private Url = 'http://sethies.com/kilosabjiapp/api/home';  // URL to web API

  constructor (private http: Http) {}

  getHeroes(): Observable<data[]> {
    return this.http.get(this.Url)
                    .map(this.extractData)
                    .catch(this.handleError);
  }

  create(name: string): Observable<data> {
	  // private Url = 'http://sethies.com/kilosabjiapp/api/home';  // URL to web API
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    return this.http.post(this.Url, { name }, options)
                    .map(this.extractData)
                    .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body.data || { };

	////console.log(let body);
  }

  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    //console.error(errMsg);
    return Observable.throw(errMsg);
  }
}*/






  //constructor(private _http: Http ) { }

  //public getCountryDetail() {


   //let _url: string = 'https://restcountries.eu/rest/v2/name/india?fullText=true';

  // let headers = new Headers({'Content-Type':'application/json'});
	// let test_this = {"name": "ravi"};
   //let _url: string="http://sethies.com/kilosabjiapp/api/home";

      //create(name: string): Observable<data> {
	  // private Url = 'http://sethies.com/kilosabjiapp/api/home';  // URL to web API
   // let headers = new Headers({ 'Content-Type': 'application/json' });
    //let options = new RequestOptions({ headers: headers });

      /* create(name: string): Observable<Hero> {
       let headers = new Headers({ 'Content-Type': 'application/json' });
       let options = new RequestOptions({ headers: headers });

      return this.http.post(this.heroesUrl, { name }, options)
                    .map(this.extractData)
                    .catch(this.handleError);
  }





   ////console.log(JSON.stringify(test_this));

	//return this._http.post(_url,  test_this , options);
                    //.catch(this.handleError);

	//  return this._http.post( _url,test_this );

	//  return this._http.get(encoded_data, this._url, options).map(
          //  (res: Response) => res.json() || {}

   }
}

/*import {Injectable} from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

@Injectable()

 export class MydataService {
	 public headers:Headers;

	 constructor( private _http: Http){
		//this.method =_http.get;
	    //this.http = http;

        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
	   //  this.headers.append('Accept', 'application/json');
		// this.headers.append('Access-Control-Allow-Origin', '*');
		 this.headers.append('Access-Control-Allow-Origin','*');
	  // this.headers.append('Access-Control-Allow-Headers', 'Content-Type');

	 }
	  public getCountryDetail() {
	 let _url: string = 'https://restcountries.eu/rest/v2/name/india?fullText=true';
	 //let _url: string = 'http://192.168.0.104/kilosabji/api/home';
	// let _url: string = 'http://sethies.com/kilosabjiapp/api/home';
	 return this._http.get(_url,{headers:this.headers});
	 // return this._http.get( _url );
   }

 }*/



// WEBPACK FOOTER //
// ./src/pages/home/mydata.service.ts